<script lang="ts">

    export let webpUrl : any = "";
    export let pngUrl : any;
    export let pngUrlMobile : any = "";
    export let webpUrlMobile : any = "";
    export let alt : string = "";
    export let loading : "eager" | "lazy" = "lazy";
    export let width : string = "";
    export let height: string = "";
    export let className: string = "";
    export let breakPoint: number = 768;

</script>

<img src={pngUrl} {alt} class={className}/>
<!-- <picture class={className}>
    <source media="(min-width: {breakPoint}px)" srcset={webpUrl} type="image/webp">
    <source media="(min-width: {breakPoint}px)" srcset={pngUrl} type="image/png">
    {#if webpUrlMobile}<source media="(max-width: {breakPoint - 1}px)" srcset={webpUrlMobile} type="image/webp">{/if}
    {#if pngUrlMobile}<source media="(max-width: {breakPoint - 1}px)" srcset={pngUrlMobile} type="image/png">{/if}
    <img src={pngUrl} {alt} loading={loading}>
</picture> -->